import { COUNTRIES } from "@/lib/country";

export type VerifyPurpose = "reset" | "login";

export type EmailFormValues = { email: string };

type SearchParams = Record<string, string | string[] | undefined>;

const first = (v: string | string[] | undefined) => (Array.isArray(v) ? v[0] : v);

/** Only same-origin paths survive: a single leading "/", no "//" or "/\" (protocol-relative). */
export function safeRedirect(value: string | string[] | null | undefined): string {
  const v = Array.isArray(value) ? value[0] : value;
  if (!v || !v.startsWith("/") || v.startsWith("//") || v.startsWith("/\\")) return "/";
  return v;
}

export function withRedirect(path: string, redirect: string): string {
  return redirect === "/" ? path : `${path}?redirect=${encodeURIComponent(redirect)}`;
}

export function dialCodeOf(isoCode: string): string {
  return COUNTRIES.find((c) => c.code === isoCode)?.dial_code ?? "+62";
}

export function parseEmail(sp: SearchParams): string | null {
  return first(sp.email)?.trim() || null;
}

export function parsePurpose(sp: SearchParams): VerifyPurpose {
  return first(sp.purpose) === "login" ? "login" : "reset";
}

export function pageHref(
  path: string,
  email: string,
  extra: Record<string, string | undefined> = {},
): string {
  const p = new URLSearchParams({ email });
  for (const [k, v] of Object.entries(extra)) if (v) p.set(k, v);
  return `${path}?${p.toString()}`;
}

export const OTP_LENGTH = 4;
export const OTP_RESEND_SECONDS = 60;
